export default __webpack_public_path__ + "static/media/ss_7de6750a31ea464ad94b19573c173cb6118b2d70.1920x1080.30c5d798.jpg";